import {
  Box,
  Chip,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import VisibilityIcon from "@mui/icons-material/Visibility";

import GlassCard from "./GlassCard";
import SectionTitle from "./SectionTitle";
import InfoRow from "./InfoRow";

export default function TabDemanda({ lawsuit, onPreviewLawsuit }) {

  if (!lawsuit) {
    return (
      <GlassCard>
        <Typography sx={{ fontWeight: 950 }}>
          No hay título asociado
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          Si el expediente tiene un título, se mostrará en esta
          sección.
        </Typography>
      </GlassCard>
    );
  }

  return (
    <GlassCard>
      <SectionTitle
        icon={<InsertDriveFileIcon />}
        title="Título"
        description="Detalle del título asociado al expediente."
        right={
          <Tooltip
            title={
              lawsuit.has_pdf
                ? "Vista previa PDF"
                : "No tiene archivo registrado: se migró históricamente sin archivo adjunto."
            }
          >
            <span>
              <IconButton
                onClick={() => onPreviewLawsuit(lawsuit.id)}
                disabled={!lawsuit.has_pdf}
                sx={{
                  borderRadius: 2,
                  bgcolor: "rgba(0,0,0,0.04)",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.07)" },
                }}
              >
                <VisibilityIcon />
              </IconButton>
            </span>
          </Tooltip>
        }
      />

      <Divider sx={{ opacity: 0.6, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <InfoRow label="Código JEX" value={lawsuit.code} />
          <InfoRow label="Tipo" value={lawsuit.type} />
          <InfoRow
            label="CUIT/DNI"
            value={
              lawsuit.dni_cuit && lawsuit.dni_cuit !== "0"
                ? lawsuit.dni_cuit
                : "No registrado"
            }
          />
          <InfoRow
            label="Nombre / Razón social"
            value={`${lawsuit.first_name || ""} ${lawsuit.last_name || ""}`.trim()}
          />
          <InfoRow label="Dirección" value={lawsuit.address} />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <InfoRow
            label="Identificación"
            value={lawsuit.identification}
          />
          <InfoRow
            label="Monto"
            value={
              lawsuit.amount
                ? new Intl.NumberFormat("es-AR", {
                    style: "currency",
                    currency: "ARS",
                    minimumFractionDigits: 2,
                  }).format(lawsuit.amount)
                : "—"
            }
          />
          <InfoRow
            label="Fecha de mora"
            value={
              lawsuit.date
                ? new Date(lawsuit.date).toLocaleDateString(
                    "es-AR",
                    {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    },
                  )
                : "—"
            }
          />

          <Box sx={{ mt: 1 }}>
            <Chip
              label={(
                lawsuit.status_label ||
                lawsuit.status ||
                "—"
              ).toString()}
              variant="outlined"
              sx={{ borderRadius: 999, fontWeight: 900, px: 1 }}
            />
          </Box>
        </Grid>
      </Grid>
    </GlassCard>
  );
}
